(function ($) {

    'use strict';

    // 分页加载产品组件
    class Waterfall extends HTMLElement {
        constructor() {
            // 在构造器中先调用一下 super
            super();
            // 样式
            const style = `
                <style>
                    .flex-center {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .flex-left {
                        display: flex;
                        justify-content: left;
                        align-items: baseline;
                    }
                    .waterfall-list {
                        display: flex;
                        width: 100%;
                        flex-wrap: wrap;
                    }
                    .waterfall-item {
                        flex: 0 0 20%;
                        padding: 0 0 24px 16px;
                        box-sizing: border-box;
                    }
                    .product-link {
                        text-decoration: none;
                        color: #1D1D1D;
                    }
                    .product-title {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        height: 18px;
                        line-height: 18px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                        font-family: Roboto-Regular, Roboto;
                        margin: 15px 0 4px 0;
                    }
                    .product-price {
                        font-size: 18px;
                        font-family: Roboto-Bold, Roboto;
                        font-weight: bold;
                        color: #fa7800;
                        height: 22px;
                        line-height: 22px;
                        margin-right: 6px;
                    }
                    .product-compare-price {
                        text-decoration: line-through;
                        display: inline-block;
                        height: 14px;
                        line-height: 14px;
                        font-size: 12px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #959595;
                    }
                    .add-to-cart__button {
                        padding: 8px 14px;
                        background-color: #FFFFFF;
                        border-radius: 4px;
                        border: 1px solid #01A978;
                        cursor: pointer;
                        margin-top: 10px;
                        height: 14px;
                        line-height: 14px;
                        font-size: 12px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #01A978;
                    }
                    .add-to-cart__button.loading {
                        background-color: #ddd;
                        color: #555;
                    }
                    .add-to-cart__button.loading::after {
                        content: "";
                        display: inline-block;
                        width: 0.8em;
                        height: 0.8em;
                        margin-left: 0.5em;
                        border-radius: 50%;
                        border: 3px solid #fff;
                        border-top-color: #777;
                        animation: spin 1s linear infinite;
                    }
                    .loading-wrapper, .warning-wrapper {
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        z-index: 99999;
                        display:flex;
                        justify-content:center;
                        align-items: flex-end;
                        background-color: rgba(255,255,255,0.4);
                    }

                    .warning-message {
                        background-color: #fef0f0;
                        border: 1px solid #fde2e2;
                        border-radius: 4px;
                        padding: 10px 15px;
                        top: 20px;
                        display: flex;
                        align-items: center;
                        color: #F56C6C;
                    }
                    .warning-message-content {
                        margin: 0;
                    }
                    .waterfall-container {
                        position: relative;
                        margin-left: -16px;
                    }
                    .waterfall-title {
                        font-size: 24px;
                        font-family: Roboto-Bold, Roboto;
                        font-weight: bold;
                        color: #333333;
                        line-height: 32px;
                        margin: 0 0 16px 12px;
                    }
                    .hide {
                        display: none;
                    }
                    .product-image {
                        position:relative;
                        display: block;
                        text-align: center;
                        font-size: 0;
                        padding-top:100%;
                    }
                    .product-image img{ 
                        position: absolute;
                        top: 0;
                        left: 0;
                        width:100%;
                        height:100%;
                    }
                    .load-more-btn {
                        cursor: pointer;
                        color: #01A978;
                        width: 112px;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        background: #FFFFFF;
                        font-size: 12px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                    }
                    .load-more-btn::after {
                        display: inline-block;
                        width: 6px;
                        height: 6px;
                        content: '';
                        border-top: 1px solid #01A978;  /* 箭头颜色 */
                        border-right: 1px solid #01A978; /* 箭头颜色 */
                        transform-origin:center;
                        transform: rotate(135deg) translate(-8px,-5px);
                    }
                    .no-more-products {
                        height: 14px;
                        font-size: 12px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #333333;
                        line-height: 14px;
                    }
                    .spinner {
                        border: 2px solid #00c601;
                        border-top-color: #cccccc;
                        border-radius: 50%;
                        width: 60px;
                        height: 60px;
                        animation: spin 0.6s linear infinite;
                        margin-bottom: 100px;
                    }
                    @keyframes spin {
                        to {
                            transform: rotate(360deg);
                        }
                    }
                    @media (max-width: 768px) {
                        .waterfall-container {
                            padding: 16px;
                        }
                        .waterfall-item {
                            flex: 0 0 50%;
                        }
                    } 
                </style>
            `;            
            // 模板
            const template = `
                <div class="waterfall-container">
                    <div class="waterfall-title">Customers also bought these</div>
                    <div class="waterfall-list"></div>
                    <div class="flex-center">
                        <div class="load-more-btn">Show More</div>
                        <div class="no-more-products hide">No more products</div>
                    </div>
                    <div class="loading-wrapper hide">
                        <div class="spinner"></div>
                    </div>
                    <div class="warning-wrapper hide">
                        <div class="warning-message"></div>
                    </div>
                </div>
            `;
            /**
             * 创建一个 shadow root，给指定的元素挂载一个 Shadow DOM，并且返回对 ShadowRoot 的引用
             * open: shadow root 元素可以从 js 外部访问根节点
             * closed: 拒绝从 js 外部访问关闭的 shadow root 节点
             */
            const shadowRoot = this.attachShadow({ mode: 'open' });
            // 向 shadow root 上挂载样式、模板
            shadowRoot.innerHTML = `${style}${template}`;
            // 根容器
            this.waterfallContainer = shadowRoot.querySelector('.waterfall-container');

            // PC端每页数据量
            this.PCPageSize = 20;
            // 移动端每页数据量
            const mobilePageSize = 8;            
            // 非首次每页数据量，PC端20，移动端8
            this.pageSize = window.innerWidth > 768 ? this.PCPageSize : mobilePageSize;
            // 产品数据
            this.products = [];
            // 下个分页的标尺
            this.endCursor = null;
            // 观察者
            this.observer=null

        }

        // 生命周期回调，当自定义元素第一次被连接到文档 DOM 时被调用
        async connectedCallback() {
            // 初始化数据
            await this.loadProducts(this.PCPageSize);
            // 绑定事件
            this.bindShowMoreEvents();
            this.bindTrackingEvents();
        }

        disconnectedCallback() {
          this.observer && this.observer.disconnect();
        }



        // 获取组件属性
        static get observedAttributes() {
            return ['store-name', 'access-token', 'collection-handle'];
        }

        // 商城名
        get storeName() {
            return this.getAttribute('store-name');
        }

        // 权限
        get accessToken() {
            return this.getAttribute('access-token');
        }

        // 集合页handle
        get collectionHandle() {
            return this.getAttribute('collection-handle');
        }
        
        // 判断是否为购物车页
        isInCartPage() {
            // 获取当前页面的 URL
            const currentUrl = window.location.href;
            // 判断 URL 中是否包含 "/cart" 路径
            return /\b\/cart\b/.test(currentUrl);
        }

        // 保留两位小数
        financial(x) {
            return Number.parseFloat(x).toFixed(2);
        }

        // html字符串转dom节点
        parseToDOM(htmlStr) {
            const placeholder = document.createElement('div');
            placeholder.innerHTML = htmlStr.trim();
            return placeholder.childNodes[0];
        }

        /**
         * 异常提示
         * @param {*} message 提示语
         * @param {*} duration 展示时长
         */
        showWarning(message, duration) {
            // 异常提示
            const warningWrapper = this.waterfallContainer.querySelector('.warning-wrapper');
            // 提示信息
            const warningMessage =  this.waterfallContainer.querySelector('.warning-message');
            // 显示
            warningWrapper.classList.remove('hide');
            // 提示语
            warningMessage.innerHTML = message;
            setTimeout(() => {
                // 关闭
                warningWrapper.classList.add('hide');
            }, duration);
        }

        /**
         * 请求方法封装
         * @param {*} params apiUrl、method、headers、body
         * @returns 
         */
        async request(params) {
            const response = await fetch(params.apiUrl, {
                method: params.method,
                headers: {
                    'Content-Type': 'application/json',
                    ...(params.headers || {})
                },
                body: params.body,
            }).catch((err) => {
                // 网络异常提示
                this.showWarning(err.message, 4000);
                throw { message: `${err.message}` };
            });
            if (response.ok) {
                return response.json();
            } else {
                // 状态码异常提示
                this.showWarning(response.statusText, 4000);
                throw { message: `${response.status}: ${response.statusText}` };
            }
        }
    
        // 数据渲染
        render(products) {
            if (!Array.isArray(products)) {
                return;
            }
            // 文档碎片保存，避免频繁操作DOM
            const fragment = new DocumentFragment();
            // 列表容器
            const waterfallList = this.waterfallContainer.querySelector('.waterfall-list');
            products.forEach((product) => { 
                const price = product.priceRange.minVariantPrice.amount;
                const compareAtPrice = product.compareAtPriceRange.minVariantPrice.amount;
                const htmlStr = `
                <div class="waterfall-item" id="${product.id}">
                    <a class="product-link product-image" href="${product.onlineStoreUrl}">
                        <img id="product-image" data-src="${product.featuredImage.url}" loading="lazy">
                    </a>
                    <a id="product-title" class="product-link product-title" href="${product.onlineStoreUrl}">${product.title}</a>
                    <div class="item-box">
                        <div class="flex-left">
                            ${Number(compareAtPrice) > Number(price) ? `<div class="product-price">$${price}</div><div class="product-compare-price">$${compareAtPrice}</div>` : `<div class="product-price" style="color: #333333">$${price}</div>`}
                        </div>
                        <estimated-price price="${Number(price) * 100}" config=${product.estimated_price?.value}></estimated-price>
                        <div class="flex-center add-to-cart__button" id="add-to-cart__button">Add to Cart</div>
                    </div>
                </div>
                `;
                // html字符串转dom
                const htmlDom = this.parseToDOM(htmlStr);
                // dom节点暂存到文档碎片
                fragment.append(htmlDom);
            });
            // 收集的列表一起放入列表容器
            waterfallList.append(fragment);

            // 绑定图片懒加载事件
            this.bindImgLazyLoadEvents();
        }

        // 绑定加载更多点击事件
        bindShowMoreEvents() {
          const loadMoreBtn = this.waterfallContainer.querySelector('.load-more-btn');
          loadMoreBtn && loadMoreBtn.addEventListener('click', () => {
              this.loadProducts(this.pageSize);
          });
        }

        // 绑定图片懒加载事件
        bindImgLazyLoadEvents(){
          this.observer && this.observer.disconnect();
          const imgs=this.shadowRoot.querySelectorAll('.product-image img');
          this.observer=CgGlobalUtils.lazyLoad({target: imgs});
        }

        // 用事件委托机制，绑定埋点事件，避免每个节点绑定事件
        bindTrackingEvents() {
            this.waterfallContainer.addEventListener('click', (event) => {
                const evt = event || window.event;
                const target = evt.target; // 事件分派到的对象的引用
                let productIndex = ''; // 商品元素索引，用于埋点传参
                let productId = ''; // 商品id
                // 埋点参数
                const MktClickData = {
                    resource_location: 'product_detail_page', // 资源位所在位置
                    resource_module: '', // 资源位所在模块
                    resource_number: '', // 资源位所在位置序号
                    resource_id: '', // 资源位内素材ID
                    resource_name: '', // 资源位内素材名称
                    sku: '' // 商品sku
                };
                // 点击加入购物车按钮，把商品加入购物车
                if (target.id === 'add-to-cart__button') {
                    productId = target.parentNode.parentNode.id;
                    this.addProductToCart(target);
                }
                // 图片链接埋点
                if (target.id === 'product-image') {
                    productId = target.parentNode.parentNode.id;
                    MktClickData.resource_module = 'product_recommend_pic';
                    MktClickData.resource_id = target.parentNode.getAttribute('href') || '';
                }
                // 标题链接埋点
                if (target.id === 'product-title') {
                    productId = target.parentNode.id;
                    MktClickData.resource_module = 'product_recommend_title';
                    MktClickData.resource_id = target.getAttribute('href') || '';
                }
                if (productId) {
                    // 当前商品信息
                    const product = this.products.find((product, index) => {
                        productIndex = index;
                        return product.id === productId;
                    });
                    const variant = product.variants.nodes[0];
                    // 加入购物车上报埋点
                    if (target.id === 'add-to-cart__button') {
                        SenseBlock.track('AddToCart', {
                            sku: variant ? variant.sku: '',
                            commodity_price: variant.price.amount,
                            commodity_quantity: 1,
                            is_recommend_part: true
                        });
                    }
                    // 图片、标题链接埋点
                    if (target.id === 'product-image' || target.id === 'product-title') {
                        MktClickData.resource_number = productIndex;
                        MktClickData.resource_name = product.title;
                        MktClickData.sku = variant.sku;
                        SenseBlock.track('MktClick', MktClickData);
                        SenseBlock.gtmTrack('key_clicks', MktClickData);
                    }
                }
            });
        }

        /**
         * 加载产品数据
         * @param {*} pageSize 每页数据量
         * @returns 
         */
        async loadProducts(pageSize) {
            // 加载提示容器
            const loadingWrapper = this.waterfallContainer.querySelector('.loading-wrapper')
            // 分页开始位置
            const cursor = this.endCursor;
            // graphql查询schema
            const query = `{
                collection(handle: "${this.collectionHandle}") {
                    id
                    title
                    products(first: ${pageSize}, after: ${cursor ? `"${cursor}"` : null} ) {
                        pageInfo {
                            hasNextPage
                            endCursor
                        }
                        nodes {
                            id
                            title
                            onlineStoreUrl
                            handle
                            featuredImage {
                                url
                            }
                            variants(first: 50) {
                                nodes {
                                    id
                                    title
                                    sku
                                    price {
                                        amount
                                    }
                                }
                            }
                            priceRange {
                                minVariantPrice {
                                    amount
                                }
                            }
                            compareAtPriceRange {
                                minVariantPrice {
                                    amount
                                }
                            }
                            estimated_price:metafield(namespace:"makeblock",key: "estimated_price") {
                                value
                            }
                        }
                    }
                }
            }
            `;
            // 请求截流，防止误操作多次请求
            if (!loadingWrapper.classList.contains('hide')) {
                return;
            }
            // 显示加载指示图标
            loadingWrapper.classList.remove('hide');
            // 参数
            const params = {
                apiUrl: `https://${this.storeName}.myshopify.com/api/2023-07/graphql.json`,
                method: 'POST',
                headers: {
                    'x-shopify-storefront-access-token': this.accessToken
                },
                body: JSON.stringify({ query })
            }
            // 发送请求
            const result = await this.request(params).finally(() => {
                // 重置请求状态
                loadingWrapper.classList.add('hide');
            });
            // 产品数据
            if (result && result.data && result.data.collection && result.data.collection.products && Array.isArray(result.data.collection.products.nodes)) {
                const productsData = result.data.collection.products;
                const products = productsData.nodes.map(product => {
                    // 价格数据保留两位小数
                    product.compareAtPriceRange.minVariantPrice.amount = this.financial(product.compareAtPriceRange.minVariantPrice.amount);
                    product.priceRange.minVariantPrice.amount = this.financial(product.priceRange.minVariantPrice.amount);
                    product.id = product.id.split('gid://shopify/Product/')[1];
                    return product;
                });
                // 渲染数据当前页
                this.render(products);
                // 收集产品所有数据
                this.products = this.products.concat(products);
                // 分页起始标识
                this.endCursor = productsData.pageInfo.endCursor;
                // 若下页无数据，加载更多按钮变为无数据提示
                if (!productsData.pageInfo.hasNextPage) {
                    this.waterfallContainer.querySelector('.load-more-btn').classList.add('hide');
                    this.waterfallContainer.querySelector('.no-more-products').classList.remove('hide');
                }
            }
        } 

        /**
         * 发起加入购物车请求
         * @param {*} id
         * @returns 
         */
        async addProductToCart(target) {
            // 商品id
            const productId = target.parentNode.parentNode.id;
            // 准备加入购物车的商品
            const addedProduct = this.products.find(product => product.id === productId);
            if (!addedProduct) {
                return;
            }
            // 默认第一个变体商品
            const variant = addedProduct.variants.nodes[0];
            // 变体商品id
            const productVariantId = variant.id.split('gid://shopify/ProductVariant/')[1];
            // 请求截流，防止误点击多次请求
            if (target.classList.contains('loading')) {
                return;
            }
            // 请求状态
            target.classList.add('loading');
            target.textContent = 'adding...';
            // 参数
            const formData = {
                id: productVariantId,
                quantity: 1
            };
            const params = {
                apiUrl: `${window.Shopify.routes.root}cart/add.js`,
                method: 'POST',
                body: JSON.stringify(formData)
            }
            // 发送请求
            await this.request(params).finally(() => {
                // 请求完毕，状态重置
                target.classList.remove('loading');
                target.textContent = 'Add to Cart';
            });
            if (theme && theme.Cart) {
                // 如果不在购物车页面, 则打开购物车弹框
                if (!this.isInCartPage()) {
                    theme.Cart.showPopup();
                }
                theme.Cart.updateData().then(() => { // 拉取最新数据
                    // 触发senseblock gtm 埋点
                    document.dispatchEvent(new CustomEvent('on::cart::added', {
                        detail: {
                            items: [formData],
                            entrance: "product_ymal"
                        }
                    }));
                    Promise.resolve(theme.Cart.updateCart()); // 更新购物车
                });
            }
        }

    }

    theme.AssetsLoader.onPageLoaded(() => {
        customElements.define('waterfall-component', Waterfall);
    });

})(jQueryTheme);